export const en = {
    'regions-transform-error-for-none-groups': 'Select an ad group to change display regions',
    'regions-transform-full-error-many': 'Unable to apply changes to display region in the selected ad groups',
    'regions-transform-full-error-one': 'Unable to apply changes to display region in the selected ad group',
    'regions-transform-full-success-many': 'Changes to display region have been applied in the selected ad groups',
    'regions-transform-full-success-one': 'Changes to display region have been applied in the selected ad group',
    'regions-transform-hint-count-campaigns': {
        one: '{count} campaign selected. Changes will be applied to all ad groups in this campaign',
        some: '{count} campaigns selected. Changes will be applied to all ad groups in these campaigns',
        many: '{count} campaigns selected. Changes will be applied to all ad groups in these campaigns',
        none: '{count} campaigns selected.'
    },
    'regions-transform-partial-success': {
        one: 'Changes to display regions have been applied in {count} ad group out of {total}',
        some: 'Changes to display regions have been applied in {count} ad groups out of {total}',
        many: 'Changes to display regions have been applied in {count} ad groups out of {total}',
        none: 'Changes to display regions have been applied in {count} ad groups out of {total}'
    },
    'regions-transform-partial-success-with-link': {
        one:
            'Changes to display regions have been applied in {count} ad group out of {total}. Unable to apply changes in the rest',
        some:
            'Changes to display regions have been applied in {count} ad groups out of {total}. Unable to apply changes in the rest',
        many:
            'Changes to display regions have been applied in {count} ad groups out of {total}. Unable to apply changes in the rest',
        none:
            'Changes to display regions have been applied in {count} ad groups out of {total}. Unable to apply changes in the rest'
    }
};
